import {
  List,
  Datagrid,
  TextField,
  EditButton,
  ShowButton,
  BooleanField,
} from "react-admin";

export function AppSettingsList(props) {
  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="id" label="ID" />
        <TextField source="name" />
        {/* <TextField source="key" /> */}
        <TextField source="value" />
        <BooleanField source="isPublic" />
        <EditButton />
        <ShowButton />
      </Datagrid>
    </List>
  );
}
